<template>
  <svg
    :viewBox="`0 0 ${2*centerX} ${2*centerY}`"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :style="{
      '--zoom': zoom,
      '--url': `url(#gradient${id})`,
      '--backGrad': backGrad,
      '--color_out': color_out
    }"
    tabindex="-1"
  >
    <defs>
      <radialGradient :id="`gradient${id}`">
        <stop offset="5%" :stop-color="color_in" />
        <stop offset="70%" :stop-color="color_out" />
        <stop offset="95%" :stop-color="color_out" />
      </radialGradient>
    </defs>
    <path
    id="shape"
    :style="pathStyle" :d="paths[0]">
      <animate
        attributeName="d"
        :from="paths[0]"
        :to="paths[1]"
        :dur="dur+'s'"
        repeatCount="indefinite"
    />
    </path>
  </svg>

</template>

<script>
import { colors, curves } from '../../utils'

export default {
  name: "Blob",
  props: [
    'id',
    'colors',
  ],
  data() {
    return {
      paths: [],

      dur: 30,
      // blur: 5,
      blur: 0,
      centerX: 75,
      centerY: 75,
      radius: 30,
      vertixCountFactor: 0.15,

      color_out : `hsl(${this.colors[0].h},${this.colors[0].s}%,${this.colors[0].l}%)`,
      color_in  : `hsl(${this.colors[1].h},${this.colors[1].s}%,${this.colors[1].l}%)`,
      backGrad  : `radial-gradient(${this.color_out} 0%, ${this.color_in}) 70%`,
      pathStyle: {},
      zoom: Math.random( 1 - 0.8 ) + 0.8,
    }
  },
  computed: {
  },
  created() {

    this.pathStyle = {
      '--dur': this.dur + 's',
      // '--blur': this.blur && this.randomInt(4, 6) + 'px',
      // '--blur': this.randomInt(4, 6) + 'px',
      '--blur': this.blur + 'px',
      strokeWidth: this.randomWidth(),
      strokeDashoffset: this.randomWidth(),
      strokeDasharray: 10,
      // strokeDasharray: `${this.randomWidth()} ${this.randomWidth()}`,
    }

    this.paths[0] = this.generateCurvyShape()
    this.paths[1] = this.generateCurvyShape()
    // setInterval(() => {
    //   this.paths[0] = this.paths[1]
    //   this.paths[1] = this.generateCurvyShape()
    // }, this.dur * 1000)

  },

  watch: {
  },

  methods: {

    generateCurvyShape() {
      return curves.generateCurvyShape({
        vertixCountFactor: this.vertixCountFactor,
        radius: this.radius,
        centerX: this.centerX,
        centerY: this.centerY
      })
    },

    randomInt: colors.randomInt,

    randomWidth() {
      return this.randomInt(0, 25)
    },

  }
}
</script>

<style scoped>
svg {
  position: absolute;
  box-sizing: border-box;
  padding: 0%;
  top: 0;
  width: 100%;
  height: 100%;
  stroke: var(--color_out);
  stroke-width: 0px;
  border: none;
  overflow: visible;
  transform-origin: center center;
  transform: scale(var(--zoom));
  background: var(--backGrad);
  transition: all var(--slow) ease;
  animation: scale 10s linear infinite alternate;
}

svg:hover {
  transform: scale(calc(1.2*var(--zoom)));
}

path {
  fill: var(--url);
  stroke: var(--color_out);
  filter:
    drop-shadow(0 0 40px var(--color_out))
    blur(var(--blur))
  ;
  /* -webkit-filter:
    drop-shadow(0 0 40px var(--color_out))
    blur(var(--blur))
  ; */
  transition:
    fill var(--dur) linear,
    stroke var(--dur) linear,
    filter var(--fast) ease
  ;
}

@keyframes scale {
  0%   { transform: scale(var(--zoom)); }
  100%  { transform: scale(calc( var(--zoom) * 1.35 )); }
  /* 100% { transform: scale(var(zoom)); } */
}

</style>
